import { AppAction, PageFilter } from '../../../../state/app';

export const FETCH_PENDING_APPROVAL_SAMPLE_DEV_PL_LIST =
  'FETCH_PENDING_APPROVAL_SAMPLE_DEV_PL_LIST';

export const fetchPendingApprovalSampleDevPlList = (paging: PageFilter): AppAction => {
  return {
    type: FETCH_PENDING_APPROVAL_SAMPLE_DEV_PL_LIST,
    payload: {
      filters: { 'HasResponded.EqualsTo': 'false' },
      paging,
    },
  };
};
